module.exports = __webpack_public_path__ + "static/media/PEL_F1.06c3265b.txt";